import { render, staticRenderFns } from "./WalletForm.vue?vue&type=template&id=6453d194&"
import script from "./WalletForm.vue?vue&type=script&lang=js&"
export * from "./WalletForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports